"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var tree_utils_1 = require("../../common/tree-utils");
var core_1 = require("@angular/core");
var measure_type_resolver_service_1 = require("../service/measure-type-resolver.service");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
/**
 * Created by Hayk.Andriasyan on 5/10/2018.
 *
 * Creates map with branch index and measurePathHolderId
 */
var BranchIndexMeasurePathHolderIdsCreator = /** @class */ (function () {
    function BranchIndexMeasurePathHolderIdsCreator(measureTypeResolverService) {
        this.measureTypeResolverService = measureTypeResolverService;
    }
    BranchIndexMeasurePathHolderIdsCreator.prototype.identifyDatasetId = function (datasetId) {
        this.measureTypeResolverService.initializeMeasurePaths(datasetId);
    };
    /**
     * @param columnRootDto
     * @returns {Map<number, number>} where key is branch index, value path holder id
     */
    BranchIndexMeasurePathHolderIdsCreator.prototype._getBranchIndexWithFirstLevelColumnMeasurePathHolderIdsMap = function (columnRootDto) {
        var children = columnRootDto.children;
        var branchIndexPathHolderIdMap = new Map();
        var branchIndex = 0;
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var element = children_1[_i];
            if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                var measure = element;
                branchIndexPathHolderIdMap.set(branchIndex, measure.measurePathHolderId);
            }
            branchIndex += tree_utils_1.TreeUtils.getColumnTreeLeafsCount(element);
        }
        return branchIndexPathHolderIdMap;
    };
    /**
     * Returns the map with branch indexes and measurePathHolderIds
     *
     * @param {ColumnRootDto} columnRootDto
     * @returns {Observable<Map<number, number>>}
     */
    BranchIndexMeasurePathHolderIdsCreator.prototype.getBranchIndexWithFirstLevelColumnMeasurePathHolderIds = function (columnRootDto) {
        var map = this._getBranchIndexWithFirstLevelColumnMeasurePathHolderIdsMap(columnRootDto);
        var pairs = Array.from(map);
        return this.measureTypeResolverService.getMeasuresByType([idm_dataset_service_client_js_1.MeasurePathType.MONEY, idm_dataset_service_client_js_1.MeasurePathType.NUMBER]).map(function (arrayOfFilteredPathHolderIds) {
            var filteredMap = new Map();
            pairs.forEach(function (pair) {
                if (arrayOfFilteredPathHolderIds.indexOf(pair[1]) !== -1) {
                    filteredMap.set(pair[0], pair[1]);
                }
            });
            return filteredMap;
        });
    };
    BranchIndexMeasurePathHolderIdsCreator = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [measure_type_resolver_service_1.MeasureTypeResolverService])
    ], BranchIndexMeasurePathHolderIdsCreator);
    return BranchIndexMeasurePathHolderIdsCreator;
}());
exports.BranchIndexMeasurePathHolderIdsCreator = BranchIndexMeasurePathHolderIdsCreator;
//# sourceMappingURL=branchindex-measurepathholder-ids-creator.js.map